import classNames from "classnames";
import Clickable from "components/Clickable";

import { BreadcrumbsProps, BreadcrumbsType } from "./Breadcrumbs.interfaces";

import styles from "./breadcrumbs.module.scss";

export const Breadcrumbs = ({ breadcrumbs, className }: BreadcrumbsProps) => {
    return (
        <ul className={classNames([styles.breadcrumbs, className])}>
            {breadcrumbs.map((breadcrumb: BreadcrumbsType) => (
                <li key={breadcrumb.id}>
                    <Clickable
                        unstyled={true}
                        href={breadcrumb.slug}
                        className={styles.link}
                    >
                        {breadcrumb.title}
                    </Clickable>
                </li>
            ))}
        </ul>
    );
};
